import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc } from '../docHelpers';

const getV10APIs = (userInfo) => {
  const isHmall =[178765, 215730, 198896, 216274, 116854, 640, 222052].includes(userInfo?.sol_no);
  const isClaimCstm = isHmall;

  return [
    {
      title: '선택작업 등록',
      url: '/doc/선택작업 등록',
      data: [
        {
          version: 'v1.0',
          url: '/work/addWorkSelect',
          method: 'POST',
          desc: (
            <ul className='style'>
              <li>
                <p>전송하는 주문데이터에 적용될 작업을 등록합니다.</p>
              </li>
              <li>
                <p>
                  호출가능한 액션은 아래와 같습니다. <br />
                  <br />
                </p>
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>주문</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SEND_INVOICE</font>
                      </td>
                      <td>
                        운송장전송 <br/>
                        <code>작업명: 송장전송</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>CONFIRM_ORDER</font>
                      </td>
                      <td>
                        주문확인(발주확인) <br/>
                        <code>작업명: 발주확인</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>DELAYED_ORDER_PAYMENT</font>
                      </td>
                      <td>
                        발주확인 전 주문(결제완료주문) 배송지연 <br/>
                        <code>작업명: 배송지연</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>DELAYED_ORDER</font>
                      </td>
                      <td>
                        신규주문 배송지연 <br/>
                        <code>작업명: 배송지연</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>UPDATE_HOPE_DATE</font>
                      </td>
                      <td>희망배송일 변경</td>
                    </tr>
                    {
                      [1, 1957, 5422, 77327, 129725, 121024, 122081, 122082].includes(userInfo?.m_no) || userInfo.aff_no === 1051 ? 
                      <tr>
                        <td width='200px'>
                          <font color='red'>PRINT_SLS_LABEL</font>
                        </td>
                        <td>샤피 SLS 송장발행</td>
                      </tr> : ''
                    }
                    {
                      isHmall ? 
                      <tr>
                        <td width='200px'>
                          <font color='red'>CANCEL_ORDER_BY_SELLER</font>
                        </td>
                        <td>판매자 직권 취소</td>
                      </tr> : ''
                    }
                  </tbody>
                </table>
                <br />
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>온라인상품</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 등록 전송(판매대기 상태의 상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EDIT_PROD_ALL</font>
                      </td>
                      <td>
                        쇼핑몰 수정 전송(수정대기 상태의 상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EDIT_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 부분수정 전송(수정대기 상태의 상품만
                        전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>STOP_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 품절 전송(판매중, 수정대기, 종료대기 상태의
                        상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>RESTORE_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 일시품절복구 전송(일시품절 상태의 상품만
                        전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD_RE</font>
                      </td>
                      <td>
                        쇼핑몰 재판매 전송(판매중지 상태의 상품만
                        전송가능합니다.)<br />
                        <code>(쇼핑몰 상품코드 유지)</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD_NEW</font>
                      </td>
                      <td>
                        쇼핑몰 재판매 전송(판매중지 상태의 상품만
                        전송가능합니다.)<br />
                        <code>(새상품으로 등록)</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SYNC_PROD_STATE</font>
                      </td>
                      <td>온라인상품 동기화</td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EXTENT_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 판매기간 연장 전송 <br /> (옥션, 지마켓,
                        바이즐, 스마트스토어, 11번가, 카카오 선물하기만 가능)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>CANCEL_PROD</font>
                      </td>
                      <td>쇼핑몰 판매중지 전송</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>문의</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SEND_CS</font>
                      </td>
                      <td>문의답변전송</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                {
                  isClaimCstm ? 
                  <>
                    <table width='700px'>
                      <tbody>
                        <tr>
                          <th colSpan='2'>클레임 주문</th>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>APPROVE_CLAIM</font>
                          </td>
                          <td>클레임 승인</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>REJECT_CLAIM</font>
                          </td>
                          <td>클레임 거절</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>COLLECT_CLAIM</font>
                          </td>
                          <td>클레임 회수완료</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>COMPLETE_CLAIM</font>
                          </td>
                          <td>클레임 완료</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>DEFER_CLAIM</font>
                          </td>
                          <td>클레임 보류</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </>
                  : ''
                }
              </li>
              {
                isClaimCstm ? 
                <>
                  <li style={{ marginBottom: "16px" }}>
                    클레임 작업 안내사항
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px", lineHeight: "2" }}>
                      <li>
                        쇼핑몰별·클레임 상태별로 작업 지원 여부가 다르니, 아래 지원 여부를 확인해주시기 바랍니다.
                        <details>
                          <summary>클레임 작업 지원 여부</summary>
                          <table
                            style={{
                              width: "950px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>작업(클레임 유형)</th>
                                <th>지그재그-포스티</th>
                                <th>베네피아</th>
                                <th>카페24</th>
                                <th>토스쇼핑</th>
                              </tr>

                              <tr>
                                <td>클레임 승인<br/><font color="red">APPROVE_CLAIM</font></td>
                                <td>
                                  <code>취소요청, 취소보류, 취소진행</code><br/>
                                  <code>반품요청, 반품보류, 반품진행</code><br/>
                                  <code>교환요청, 교환진행</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품요청, 반품진행</code><br/>
                                  <code>교환요청, 교환진행</code>
                                </td>
                                <td>
                                  <code>취소요청, 취소진행</code><br/>
                                  <code>반품요청, 반품진행</code><br/>
                                  <code>교환요청, 교환진행</code>
                                </td>
                                <td>
                                  <code>취소요청, 취소진행</code><br/>
                                  <code>반품요청, 반품진행</code><br/>
                                  <code>교환요청, 교환진행</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 거절<br/><font color="red">REJECT_CLAIM</font></td>
                                <td>
                                  <code>취소요청, 취소보류</code><br/>
                                  <code>반품요청, 반품회수완료, 반품보류</code><br/>
                                  <code>교환요청, 교환회수완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품요청, 반품진행, 반품보류</code><br/>
                                  <code>교환요청, 교환진행, 교환보류</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청, 반품진행, 반품회수완료</code><br/>
                                  <code>교환요청, 교환진행, 교환회수완료</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청, 반품회수완료</code><br/>
                                  <code>교환요청, 교환회수완료</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 회수완료<br/><font color="red">COLLECT_CLAIM</font></td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품회수완료</code><br/>
                                  <code>교환진행, 교환회수완료</code>
                                </td>
                                <td></td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품회수완료</code><br/>
                                  <code>교환진행, 교환회수완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품회수완료</code><br/>
                                  <code>교환진행, 교환회수완료</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 완료<br/><font color="red">COMPLETE_CLAIM</font></td>
                                <td>
                                  <br/>
                                  <code>반품회수완료, 반품보류, 반품완료</code><br/>
                                  <code>교환회수완료, 교환완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품보류, 반품완료</code><br/>
                                  <code>교환진행, 교환보류, 교환완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품회수완료, 반품완료</code><br/>
                                  <code>교환회수완료, 교환완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품회수완료, 반품완료</code><br/>
                                  <code>교환회수완료, 교환완료</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 보류<br/><font color="red">DEFER_CLAIM</font></td>
                                <td>
                                  <code>취소요청, 취소보류</code><br/>
                                  <code>반품요청, 반품회수완료, 반품보류</code><br/>
                                  &nbsp;
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품보류</code><br/>
                                  <code>교환진행, 교환보류</code>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>

                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>작업별·클레임 유형별로 작업 사유 코드가 다르니, 아래 지원 여부를 확인해주시기 바랍니다.
                        <details>
                          <summary>작업 사유 코드</summary>
                          아래 작업별 사유에 해당하는 코드를 파라미터 <code>claim_reason_code</code>에 입력해주시기 바랍니다. (예시: <code>'claim_reason_code': '101'</code>)
                          <table
                            style={{
                              width: "950px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>작업</th>
                                <th>취소<br/><span style={{ color: "red" }}>CANCELLATION</span></th>
                                <th>반품<br/><span style={{ color: "red" }}>RETURN</span></th>
                                <th>교환<br/><span style={{ color: "red" }}>EXCHANGE</span></th>
                              </tr>

                              <tr>
                                <td>클레임 거절<br/><font color="red">REJECT_CLAIM</font></td>

                                <td>
                                  <code>101</code>: 출고 진행중<br/>
                                  <code>102</code>: 발송완료<br/>
                                  <code>103</code>: 고객 요청 철회<br/>
                                  <code>104</code>: 판매 정책상 취소 불가<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 반품상품이 입고되지 않음<br/>
                                  <code>102</code>: 고객 변심상 철회 대행<br/>
                                  <code>103</code>: 반품불가한 상품<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 교환상품이 입고되지 않음<br/>
                                  <code>102</code>: 고객 변심상 철회 대행<br/>
                                  <code>103</code>: 교환불가한 상품<br/>
                                  <code>ETC</code>: 기타
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 보류<br/><font color="red">DEFER_CLAIM</font></td>

                                <td>
                                  <code>101</code>: 출고 상태 확인 필요<br/>
                                  <code>102</code>: 구매자와 연락되지 않음<br/>
                                  <code>103</code>: 판매 정책 검토 필요<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 반품상품이 입고되지 않음<br/>
                                  <code>102</code>: 반품 배송비가 등록되지 않음<br/>
                                  <code>103</code>: 반품 상품이 훼손됨<br/>
                                  <code>104</code>: 구매자와 연락되지 않음<br/>
                                  <code>105</code>: 반품추가금을 요청해야 함<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 교환상품이 입고되지 않음<br/>
                                  <code>102</code>: 교환 배송비가 등록되지 않음<br/>
                                  <code>103</code>: 교환 상품이 훼손됨<br/>
                                  <code>104</code>: 구매자와 연락되지 않음<br/>
                                  <code>105</code>: 교환추가금을 요청해야 함<br/>
                                  <code>ETC</code>: 기타
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>
                        운송장 정보(<code>claim_carr_no</code>, <code>claim_invoice_no</code>)가 필요한 작업은 1건의 주문만 처리 가능합니다.
                        <details>
                          <summary>운송장 정보 필요 클레임 작업</summary>
                          <table
                            style={{
                              width: "700px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>지그재그-포스티</th>
                                <th>베네피아</th>
                                <th>카페24</th>
                                <th>토스쇼핑</th>
                              </tr>
                              <tr>
                                <td>
                                  반품승인(필수 X)<br/>
                                  교환승인(필수 X)
                                </td>
                                <td></td>
                                <td>
                                  교환완료<br/>
                                  &nbsp;
                                </td>
                                <td>
                                  취소거절<br/>
                                  교환완료
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>
                        일부 쇼핑몰의 경우 클레임 작업 시 동일한 주문번호와 주문상태를 가진 주문이 자동으로 함께 처리됩니다. (쇼핑몰: 지그재그-포스티, 베네피아)
                      </li>
                    </ul>
                  </li>
                </> : ''
              }
              {
                isHmall ?
                  <li style={{ marginBottom: "16px" }}>
                    판매자 직권 취소 작업 안내사항
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px", lineHeight: "2" }}>
                      <li><code>결제완료</code>, <code>신규주문</code>, <code>출고대기</code>, <code>운송장출력</code> 상태의 주문만 처리가 가능하며, 완료된 주문은 <code>취소완료</code> 상태로 변경됩니다.</li>
                      <li>취소 사유별 코드는 아래 표를 확인해주시기 바랍니다.
                        <details>
                          <summary>취소 사유 코드</summary>
                          <table
                            style={{
                              width: "200px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <thead>
                              <tr>
                                <th>취소 사유 코드</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <code>A</code>: 고객변심<br/>
                                  <code>B</code>: 배송지연<br/>
                                  <code>C</code>: 배송불가지역<br/>
                                  <code>D</code>: 포장불량<br/>
                                  <code>E</code>: 상품 불만족<br/>
                                  <code>F</code>: 상품정보상이<br/>
                                  <code>G</code>: 서비스불만족<br/>
                                  <code>H</code>: 품절<br/>
                                  <code>I</code>: 기타<br/>
                                  <code>J</code>: 배송오류<br/>
                                  <code>K</code>: 상품불량<br/>
                                  <code>L</code>: 수출/통관 불가<br/>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ul style={{ listStyleType: "circle", paddingLeft: "20px", lineHeight: "2" }}>
                            <li>사유에 해당하는 코드를 파라미터 <code>claim_reason_code</code>에 입력해주시기 바랍니다. (예시: <code>'claim_reason_code': 'A'</code>)</li>
                            <li><code>카페24</code>의 경우, 취소 사유 코드를 입력하지 않으면 작업이 실패합니다.</li>
                            <li><code>지그재그-포스티</code>의 경우, 취소 사유 코드 입력 여부에 관계없이 <code>'품절'</code>로 처리됩니다.</li>
                          </ul>
                        </details>
                      </li>
                    </ul>
                  </li>
                : ''
              }
              <li>
                <p>운송장전송시 출고완료 상태의 주문건만 전송이 가능합니다.</p>
              </li>
              { userInfo?.aff_no !== 1051 ?
              <>
                <li>
                  <p>
                    문의답변 전송시 답변작성완료 상태의 문의만 전송 가능합니다.
                  </p>
                </li>
              </> : ''
              }
              <li>
                <p>
                  500 개 이상의 데이터를 전송하시는경우 500 개단위로 작업이
                  분할되어 등록됩니다.
                </p>
              </li>
              <li>
                <p>
                  <code>api_callback_url</code> 등록시 작업결과를 POST 방식으로
                  입력하신 주소로 전송합니다. <br />
                  - product_info 항목은 상품 작업인 경우에만 출력됩니다.<br />
                  - 전송되는 데이터 포멧은 아래의 예시를 참고해주세요.
                </p>
                <pre className='prettyprint'>
                    ---- 상품작업 결과 (성공시) ----
                    <br />{'{'}
                    <br />  "work_no": 172966702,
                    <br />  "job_name": "상품등록",
                    <br />  "status": "완료",
                    <br />  "message": [
                    <br />    "[성공] : m2024051034984a215 / 3789117229"
                    <br />  ],
                    <br />  "product_info": [
                    <br />    {'{'}
                    <br />      "c_sale_cd": "m2024051034984a215",
                    <br />      "shop_sale_no": "3789117229",
                    <br />      "status": "성공",
                    <br />      "msg": "m2024051034984a215 / 3789117229"
                    <br />    {'}'}
                    <br />  ]
                    <br />{'}'}
                    <br />
                    <br />---- 상품작업 결과 (실패시) ----
                    <br />{'{'}
                    <br />  "work_no": 172966702,
                    <br />  "job_name": "판매중지",
                    <br />  "status": "실패",
                    <br />  "message": [
                    <br />    "[실패] : m20220914f60d00d1b, ESM어드민에 [9999999999]상품이 존재하지 않습니다. ESM어드민 접속 하시어 상품을 확인해 주시기 바랍니다.",
                    <br />    "[실패] : m20220927a547a62c6, ESM어드민 상에서 [[888888888]]상품이 조회되지 않습니다. ESM 어드민으로 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />  ],
                    <br />  "product_info": [
                    <br />      {'{'}
                    <br />        "c_sale_cd": "판매자관리코드",
                    <br />        "shop_sale_no": "쇼핑몰 상품코드",
                    <br />        "status": "실패",
                    <br />        "msg": "m20220914f60d00d1b, ESM어드민에 [9999999999]상품이 존재하지 않습니다. ESM어드민 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />      {'}'},
                    <br />      {'{'}
                    <br />        "c_sale_cd": "m20220927a547a62c6",
                    <br />        "shop_sale_no": "888888888",
                    <br />        "status": "실패",
                    <br />        "msg": "m20220927a547a62c6, ESM어드민 상에서 [[888888888]]상품이 조회되지 않습니다. ESM 어드민으로 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />      {'}'}
                    <br />    ]
                    <br />  {'}'}
                    <br />
                    <br />---- 상품 외 작업 결과 (성공시) ----
                    { [1051].includes(userInfo.aff_no) ? 
                    <>
                      <br />[{'{'}
                      <br />  com: 'PLAYAUTO',
                      <br />  encver: '2.0',
                      <br />  encYn: 'N',
                      <br />  msg: '{'{'}"body":{'{'}"work_no":172279187,"job_name":"주문수집","status":"완료","message":"[성공] : 변경사항이 없습니다"{'}'},"header":'{'{'}"bizPtrId":"PLAYAUTO","callId":"playauto0001","ifCd":"PLAYAUTO","encType":"UTF-8","token":"PLAYAUTO[13.125.30.102]FTGsfgr5ht4HhfrDbBFW6j==20230010100001"{'}}'}'
                      <br />{'}'}]
                    </>
                    : 
                    <>
                      <br />{'{'}
                      <br />  "work_no": 172279187,
                      <br />  "job_name": "주문수집",
                      <br />  "status": "완료",
                      <br />  "message": [
                      <br />    "[성공] : 2건 성공 / 0건 실패 "
                      <br />  ]
                      <br />{'}'}
                    </>}
                    <br />
                    <br />---- 상품 외 작업 결과 (실패시) ----
                    <br />{'{'}
                    <br />  "work_no": 172279187,
                    <br />  "job_name": "주문수집",
                    <br />  "status": "실패",
                    <br />  "message": [
                    <br />    "[성공] : wpartner.wemakeprice.com 주문 수집 종료"
                    <br />  ]
                    <br />{'}'}
                  </pre>
              </li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'work_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '작업액션', allowedValues: [
                  'SEND_INVOICE', 'SEND_CS', 'CONFIRM_ORDER', 'DELAYED_ORDER_PAYMENT',
                  'DELAYED_ORDER', 'UPDATE_HOPE_DATE',
                  ...([1, 1957, 5422, 77327, 129725, 121024, 122081, 122082].includes(userInfo?.m_no) || userInfo.aff_no === 1051 ? ['PRINT_SLS_LABEL'] : []),
                  'REGIST_PROD', 'EDIT_PROD_ALL', 'EDIT_PROD', 'STOP_PROD',
                  'RESTORE_PROD', 'REGIST_PROD_RE', 'REGIST_PROD_NEW',
                  'SYNC_PROD_STATE', 'EXTENT_PROD', 'CANCEL_PROD',
                  ...(isClaimCstm ? ['APPROVE_CLAIM', 'REJECT_CLAIM', 'COLLECT_CLAIM', 'COMPLETE_CLAIM', 'DEFER_CLAIM'] : [])
                ] }),
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '쇼핑몰코드', sub: '온라인상품 작업시 필수입니다.' }),
            },
            {
              title: 'shop_id',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '쇼핑몰아이디', sub: '온라인상품 작업시 필수입니다.' }),
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '단일상품여부', sub: '온라인상품 작업시 사용됩니다. 단일 상품 관련 작업시 반드시 \'Y\'를 입력해주세요.',
                defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
            },
            {
              title: 'exclude_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '대상상품이 아닌경우 제외하고 작업을 진행할지의 여부', sub: '(온라인상품 수정 작업에만 적용됩니다.)',
                defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
            },
            {
              title: 'list',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({ title: '주문 또는 문의 고유번호', sub: '송장전송 작업이 아닌경우 필수입니다.<br />송장전송 작업 시 해당 필드가 없으면 출고완료 주문 전체가 송장전송됩니다.',
                notes: ['주문: uniq 또는 bundle_no', '문의: inq_uniq', '상품: c_sale_cd(판매자관리코드)'] }),
            },
            {
              title: 'edit_col',
              required: '',
              type: 'Object',
              desc: apiParamDesc({ title: '부분수정할 항목', sub: [
                  '온라인상품 부분수정 작업시 필수입니다.',
                  '수정하지 않을 항목은 입력하지 않아도 됩니다.'
                ] }),
            },
            {
              title: 'isEditName',
              required: '',
              type: 'Boolean',
              desc: '상품명',
              indent: 1,
            },
            {
              title: 'isEditPrice',
              required: '',
              type: 'Boolean',
              desc: '판매가',
              indent: 1,
            },
            {
              title: 'isEditOpt',
              required: '',
              type: 'Boolean',
              desc: '옵션',
              indent: 1,
            },
            {
              title: 'isEditAddopt',
              required: '',
              type: 'Boolean',
              desc: '추가구매옵션',
              indent: 1,
            },
            {
              title: 'isEditContent',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '상세설명', sub: '(머리말/꼬리말 포함)' }),
              indent: 1,
            },
            {
              title: 'isEditImage',
              required: '',
              type: 'Boolean',
              desc: '이미지',
              indent: 1,
            },
            {
              title: 'sync_col',
              required: '',
              type: 'Object',
              desc: apiParamDesc({ title: '상품동기화할 항목', sub: [
                  '온라인상품 동기화 작업시 필수입니다.',
                  '수정하지 않을 항목은 입력하지 않아도 됩니다.'
                ] }),
            },
            {
              title: 'status',
              required: '',
              type: 'Boolean',
              desc: '상품상태',
              indent: 1,
            },
            {
              title: 'count',
              required: '',
              type: 'Boolean',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'period',
              required: '',
              type: 'Boolean',
              desc: '상품 판매 종료일',
              indent: 1,
            },
            {
              title: 'price',
              required: '',
              type: 'Boolean',
              desc: '판매가격',
              indent: 1,
            },
            {
              title: 'extension_date',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '판매기간연장일', sub: '온라인상품 판매기간연장 작업시 필수입니다.',
                allowedValues: ['15', '30', '60', '90'] }),
            },
            {
              title: 'delay_reason',
              required: '',
              type: 'String',
              desc: '배송지연 사유',
            },
            {
              title: 'delay_date',
              required: '',
              type: 'String',
              desc: '배송지연 날짜',
            },
            {
              title: 'delay_code',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '희망배송일 변경 코드', sub: '희망배송일 변경 작업시 필수입니다.',
                allowedValues: [
                  ['DATE_CHANGED_BY_BUYER', '구매자 요청으로 인한 날짜 변경'],
                  ['INVALID_ADDRESS', '고객부재/배송정보 오류'],
                  ['CAPACITY_EXCEEDED', '배송 물량 초과'],
                  ['LOGISTICS_ISSUE', '물류사/배송사 이슈'],
                  ['SOLD_OUT', '상품 불량 및 재고 부족'],
                  ['DELAYED', '판매자 출고 지연'],
                  ['INSTALLATION_ISSUE', '상품 설치 작업 중 이슈'],
                  ['NATURAL_DISASTER', '천재지변']
                ] }),
            },
            ...(userInfo?.sol_no === 26164 ? [{
              title: 'sub_sol_no',
              required: 'O',
              type: 'Number',
              desc: '하위 계정 sol_no',
            }] : []),
            {
              title: 'show_shop_info_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '등록 작업 쇼핑몰정보 노출여부', sub: '콜백URL 결과 데이터 응답 시 사용됩니다.',
                defaultValue: 'false',
                allowedValues: ['true', 'false'] })
            },
            {
              title: 'dupl_doubt_except_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '중복의심주문 제외 여부', sub: '(\'Y\': 제외 후 작업, \'N\': 제외하지 않고 작업)',
                defaultValue: 'N' }),
            },
            {
              title: 'api_callback_url',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '작업완료시 작업결과를 수신받을 URL', sub: '해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로 전송합니다.' }),
            },
            ...(isClaimCstm ? 
            [
              {
                title: 'claim_type',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 유형', sub: '클레임 작업 시 필수입니다.',
                  allowedValues: [
                    ['CANCELLATION', '취소'],
                    ['RETURN', '반품'],
                    ['EXCHANGE', '교환']
                  ] }),
              },
              {
                title: 'claim_reason_code',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 사유 코드 / 판매자 직권 취소 사유 코드', sub: [
                    '클레임 처리(거절/보류) 작업과 판매자 직권 취소 작업에 한하여 사용됩니다.',
                    '작업별로 사유 코드 및 구분 메세지가 다르니, 본문 설명을 참고해주세요.'
                  ] })
              },
              {
                title: 'claim_reason_message',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 상세 사유 / 판매자 직권 취소 상세 사유', sub: [
                    '클레임 처리(거절/보류) 작업과 판매자 직권 취소 작업에 한하여 사용됩니다.',
                    '<code>claim_reason_code</code>를 입력하고 <code>claim_reason_message</code>를 비워둘 경우,',
                    '<code>claim_reason_code</code>에 해당하는 기본 메세지로 전송됩니다. (클레임 처리 작업에 한함)'
                  ] })
              },
              {
                title: 'claim_carr_no',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '운송장 택배사 코드', sub: [
                    '운송장 정보가 요구되는 일부 클레임 작업에 한하여 사용됩니다.(본문 설명 참고)',
                    '공통 API로 택배사 코드를 조회할 수 있습니다.',
                    '(API 문서 &gt; 공통 &gt; 택배사 코드 조회)'
                  ] })
              },
              {
                title: 'claim_invoice_no',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 운송장 번호', sub: '운송장 정보가 요구되는 일부 클레임 작업에 한하여 사용됩니다.(본문 설명 참고)' })
              }
            ] : []),
          ],
          body_example: [
            {
              _tabName: '운송장정보 쇼핑몰 전송',
              work_type: 'SEND_INVOICE',
              list: [
                '3782381925823309795',
                '3782381925823309796',
                '3782381925823309797',
              ],
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 쇼핑몰 등록',
              work_type: 'REGIST_PROD',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'Y',
              list: ['P000002018'],
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 부분수정 전송',
              work_type: 'EDIT_PROD',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['P000002018'],
              edit_col: {
                isEditName: false,
                isEditPrice: false,
                isEditOpt: true,
                isEditContent: false,
                isEditImage: false,
              },
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 수정 전송',
              work_type: 'EDIT_PROD_ALL',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['P000002018'],
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 품절전송',
              work_type: 'STOP_PROD',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'Y',
              list: ['P000002018'],
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 품절복구 전송',
              work_type: 'REGIST_PROD_RE',
              shop_cd: 'A006',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['m202103154766b7665'],
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 동기화',
              work_type: 'SYNC_PROD_STATE',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['m20210716533cbfe65'],
              sync_col: {
                status: true,
                count: true,
                period: true,
                price: true,
              },
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 판매기간 연장',
              work_type: 'EXTENT_PROD',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['m20210716533cbfe65'],
              extension_date: 15,
              api_callback_url: 'https://test.io/callback',
            },
            {
              _tabName: '온라인상품 판매중지',
              work_type: 'CANCEL_PROD',
              shop_cd: 'A001',
              shop_id: 'testshop',
              std_ol_yn: 'N',
              list: ['m20210716533cbfe65'],
              api_callback_url: 'https://test.io/callback',
            },
          ],
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과\n(실패시 error 로 출력)',
            },
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 작업번호',
              indent: 1,
            },
            {
              title: 'error_code',
              required: '',
              type: 'String',
              desc: '실패시 출력되는 에러코드',
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '성공, 실패 메세지',
              indent: 1,
            },
            {
              title: 'list',
              required: '',
              type: 'String[]',
              desc: '등록한 list 정보\n(성공인경우 출력)\n(주문작업인 경우 list 에 uniq 값을 넣었어도 묶음번호 데이터로 출력)',
              indent: 1,
            }
          ],
          response_example: {
            "results": [
                {
                    "work_no": 487772398,
                    "message": "작업이 정상적으로 등록되었습니다.",
                    "list": [
                        "3938009934902534",
                        "3938713558156561"
                    ]
                }
            ]
        },
          error_example: {
            "error": [
                {
                    "work_no": 0,
                    "error_code": "e6999",
                    "messages": [
                        "작업등록에 실패하였습니다."
                    ]
                }
            ]
        }
        },
      ],
    },
    {
      title: '작업결과 조회',
      url: '/doc/작업결과 조회',
      data: [
        {
          version: 'v1.0',
          url: '/work/:work_no',
          method: 'GET',
          desc: (
            <ul className='style'>
              <li>등록된 작업결과를 조회합니다.</li>
              <li>완료 상태의 작업만 조회됩니다.</li>
              <li>진행중 또는 대기상태의 작업은 조회되지 않습니다.</li>
              <li>작업등록시 리턴된 work_no 를 입력하여 조회 가능합니다.</li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '작업번호',
            },
          ],
          body_example: {
            work_no: 11591018,
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '조회하는 작업',
            },
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '작업번호',
              indent: 1,
            },
            {
              title: 'job_name',
              required: 'O',
              type: 'String',
              desc: '작업명',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '작업 상태', allowedValues: ['완료', '실패'] }),
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String[]',
              desc: apiParamDesc({ title: '결과 메세지', sub: '(성공 또는 실패)' }),
              indent: 1,
            },
          ],
          response_example: {
            results: {
              job_name: '송장전송',
              status: '실패',
              message: [
                '[실패] : 7668708872786275 : 상품코드가 비어있습니다. 주문정보를 확인해 주세요.',
                '[실패] : 7668708872786276 : 상품코드가 비어있습니다. 주문정보를 확인해 주세요.',
              ],
            },
          },
        },
      ],
    },
    {
      title: '작업리스트 조회',
      url: '/doc/작업리스트 조회',
      data: [
        {
          version: 'v1.0',
          url: '/work/list',
          desc: '작업 리스트를 가져옵니다.',
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '검색 시작 값', sub: '기본값 0부터 시작됩니다.',
                defaultValue: '0',
                notes: [
                  'start: 0, length: 100 으로 검색한 경우, 검색결과의 index 0-100건까지 검색됩니다.',
                  '다음 주문건을 검색하기 위해서는 이전 입력한 start, length 프로퍼티의 값을 고려하여 start: 100 을 입력하여 호출합니다.'
                ] })
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 작업 갯수', sub: [
                  '최대 3000건 단위로 검색 가능합니다.',
                  'Max value: <code>100</code>'
                ],
                defaultValue: '25' }),
            },
            {
              title: 'date_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '날짜검색타입', allowedValues: [
                  ['work_wdate', '작업등록일'],
                  ['work_sdate', '작업시작일'],
                  ['work_edate', '작업종료일']
                ] }),
            },
            {
              title: 'sdate',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '쇼핑몰코드', sub: '(옥션:A001, 지마켓: A006, 11번가: A112, 바이즐: A027...)' }),
            },
            {
              title: 'shop_id',
              required: '',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'status',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({ title: '작업상태', sub: '전체조회시 ["ALL"]',
                allowedValues: ['완료', '실패', '오류', '부분실패', '대기', '진행중'] }),
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '멀티검색 키', allowedValues: [
                  ['work_no', '작업번호']
                ] }),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String',
              desc: '멀티검색어 ( \\n 으로 묶어서 전송 ) ex> 718645439\\n717191985\\n728472847',
            }
          ],
          body_example: {
            start: 0,
            length: 50,
            date_type: 'work_wdate',
            sdate: '2020-03-10',
            edate: '2020-04-10',
            shop_cd: '',
            shop_id: '',
            status: ['완료', '실패'],
            multi_type: 'work_no',
            multi_search_word: ''
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '',
            },
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '작업번호',
              indent: 1,
            },
            {
              title: 'job_name',
              required: 'O',
              type: 'String',
              desc: '작업명',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '작업 상태', allowedValues: ['완료', '실패', '오류', '대기중', '진행중'] }),
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String[]',
              desc: '결과 메세지 \n(성공 또는 실패)',
              indent: 1,
            }
          ],
          response_example: {
            results: [
              {
                "work_no": 723410626,
                "job_name": "송장전송",
                "status": "실패",
                "message": [
                    "[실패] : 202503219924517 202503219924517-001 : 배송대기 상태가 아닌 섹션은 배송중 상태로 변경할 수 없습니다.",
                    "[실패] : 202503219924517 202503219924517-003 : 배송대기 상태가 아닌 섹션은 배송중 상태로 변경할 수 없습니다.",
                    "[실패] : 202503219924517 202503219924517-002 : 배송대기 상태가 아닌 섹션은 배송중 상태로 변경할 수 없습니다."
                ]
              },
              {
                  "work_no": 723408982,
                  "job_name": "판매중지",
                  "status": "오류",
                  "message": [
                      "[실패] : API KEY가 없습니다."
                  ]
              },
              {
                  "work_no": 718645438,
                  "job_name": "주문수집",
                  "status": "완료",
                  "message": [
                      "[성공] : 1건 성공 / 0건 실패 "
                  ]
              }
            ]
          },
        },
      ]
    },
  ];
};

export default getV10APIs;
